(function () {
  "use strict";

  var CLEAR_ERROR = "We couldn't clear your cart. Please try again.";

  var modal = null;
  var errorEl = null;
  var confirmBtn = null;
  var lastTrigger = null;
  var busy = false;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function isCartPage() {
    var vars = window.themeVariables;
    if (vars && vars.settings && vars.settings.pageType) return vars.settings.pageType === "cart";
    return window.location.pathname.replace(/\/+$/, "").split("/").pop() === "cart";
  }

  function findModal() {
    if (modal && modal.isConnected) return modal;
    modal = document.querySelector("[data-cart-clear-modal]");
    if (!modal) return null;
    errorEl = modal.querySelector("[data-cart-clear-error]");
    confirmBtn = modal.querySelector("[data-cart-clear-confirm]");
    return modal;
  }

  function setError(message) {
    if (!errorEl) return;
    errorEl.textContent = message || "";
    errorEl.hidden = !message;
  }

  function openModal(trigger) {
    if (!findModal()) return;
    lastTrigger = trigger || null;
    setError(null);
    modal.hidden = false;
    document.addEventListener("keydown", onKeydown);
    if (confirmBtn) confirmBtn.focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.removeEventListener("keydown", onKeydown);
    if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
    lastTrigger = null;
  }

  function onKeydown(event) {
    if (event.key === "Escape" || event.key === "Esc") {
      event.preventDefault();
      closeModal();
    }
  }

  function clearCart() {
    if (busy) return;
    busy = true;
    setError(null);
    if (confirmBtn) confirmBtn.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    fetch(routeRoot() + "cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart/clear.js responded " + response.status);
        return response.json();
      })
      .then(function () {
        if (isCartPage()) { window.location.reload(); return; }
        closeModal();
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      })
      .catch(function (err) {
        console && console.warn && console.warn("[CartClear]", err);
        setError(CLEAR_ERROR);
      })
      .then(function () {
        busy = false;
        if (confirmBtn) confirmBtn.removeAttribute("aria-busy");
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      });
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest(".cart-clear-button");
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }
    if (target.closest("[data-cart-clear-cancel]")) {
      event.preventDefault();
      closeModal();
      return;
    }
    if (target.closest("[data-cart-clear-confirm]")) {
      event.preventDefault();
      clearCart();
    }
  });
})();
